import React, { FC, useState, ReactNode } from 'react';
import styled from '@emotion/styled';

export interface CheckboxProps {
  checked: boolean;
  indeterminate: boolean;
  onChange?: (ev: React.ChangeEvent<HTMLInputElement>) => void;
  children: ReactNode;
}

const CheckboxWrapper = styled.div`
  display: flex;
  position: relative;
  padding-left: 24px;
  user-select: none;
  align-items: center;
  padding-right: 8px;
  width: calc(100% - 32px);
  & label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const CheckMark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  border: 2px solid #bdcad2;
  border-radius: 3px;
  &:after {
    left: 5px;
    top: 3px;
    border: solid #7ab800;
    border-width: 0 2px 2px 0;
    width: 4px;
    height: 8px;
    transform: rotate(45deg);
    content: '';
    position: absolute;
    display: none;
  }
`;
const IndeteminateMark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  border: 2px solid #bdcad2;
  border-radius: 3px;
  &:after {
    left: 2px;
    top: 6px;
    background-color: #7ab800;
    width: 10px;
    height: 2px;
    content: '';
    position: absolute;
    display: none;
  }
`;

const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  z-index: 10;
  &:checked ~ span:after {
    display: block;
  }
  &:checked ~ span {
    background-color: #ffffff;
  }
`;

const Checkbox: FC<CheckboxProps> = props => {
  const { indeterminate, checked } = props;
  const preventDefault = (ev: React.MouseEvent) => ev.preventDefault();
  const handleCheckboxOnChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
      ev.stopPropagation();
      return props.onChange(ev);
    }
  };
  return (
    <CheckboxWrapper>
      <CheckboxInput
        checked={checked || indeterminate}
        onChange={handleCheckboxOnChange}
        type="checkbox"
      />
      <label onClick={preventDefault}>{props.children}</label>
      {indeterminate ? <IndeteminateMark></IndeteminateMark> : <CheckMark></CheckMark>}
    </CheckboxWrapper>
  );
};

const MemoizedCheckbox = React.memo(Checkbox);
export { MemoizedCheckbox as Checkbox, MemoizedCheckbox as default };
